import React, { useState } from 'react';
import { createUserWithEmailAndPassword, sendEmailVerification, getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import emailjs from 'emailjs-com'; // Importar emailjs
import './RegisterForm.css';
import logor from '../images/Logo5.png';
import { FaRegEye } from "react-icons/fa"; // Importar el icono
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const RegisterForm = ({ handleTabChange }) => {
  const [registerForm, setRegisterForm] = useState({
    name: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone:'',
    role:'user',
    isProvider: false, // Checkbox para indicar si es proveedor
    tipoUser: 'persona',
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // Estado para controlar visibilidad de contraseña
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false); // Controlar visibilidad del modal
  const [providerForm, setProviderForm] = useState({
    companyName: '',
    ruc: '',
    phone_em: '',
    city: '',
    sector: '',
    parish: '',
    mainStreet: '',
    secondaryStreet: '',
    number_em: '',
    postalCode: '',
    reference: '',

  });
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const [isFormSubmitted, setIsFormSubmitted] = useState(false); // Estado para verificar si el formulario fue enviado

  const handleRegisterChange = (e) => {
    const { id, value, type, checked } = e.target;
    setRegisterForm((prevForm) => {
      const newValue = type === 'checkbox' ? checked : value;
      console.log(`Field: ${id}, Value: ${newValue}`);
      return {
        ...prevForm,
        [id]: newValue,
      };
    });
  };

  const handleProviderChange = (e) => {
    const { id, value } = e.target;
    setProviderForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };
// Función de validación del formulario
const validateForm = () => {
  const formErrors = {};

  // Validaciones
  if (!providerForm.companyName) formErrors.companyName = 'Razón Social es requerida';
  if (!providerForm.ruc) formErrors.ruc = 'RUC es requerido';
  if (!providerForm.phone_em) formErrors.phone_em = 'Teléfono es requerido';
  if (!providerForm.city) formErrors.city = 'Ciudad es requerida';
  if (!providerForm.sector) formErrors.sector = 'Sector es requerido';
  if (!providerForm.parish) formErrors.parish = 'Parroquia es requerida';
  if (!providerForm.mainStreet) formErrors.mainStreet = 'Calle Principal es requerida';
  if (!providerForm.secondaryStreet) formErrors.secondaryStreet = 'Calle Secundaria es requerida';
  if (!providerForm.number_em) formErrors.number_em = 'Número es requerido';
  if (!providerForm.postalCode) formErrors.postalCode = 'Código Postal es requerido';
  if (!providerForm.reference) formErrors.reference = 'Referencia es requerida';

  return formErrors;
};

// Función para manejar el submit del formulario
const handleProviderSubmit = (e) => {
  e.preventDefault();

  // Validación
  const formErrors = validateForm();
  setErrors(formErrors);

  if (Object.keys(formErrors).length === 0) {
    // No hay errores, proceder a guardar el proveedor
    console.log('Proveedor guardado exitosamente:', providerForm);

    // Abrir el modal de éxito
    setIsModalOpen(true);
    setIsFormSubmitted(true); // Marcar el formulario como enviado
  }
};


const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    const formErrors = {};

    // Validaciones para el formulario de registro general
    if (!registerForm.name) formErrors.name = 'Nombre es requerido';
    if (!registerForm.lastName) formErrors.lastName = 'Apellido es requerido';
    if (!registerForm.email) formErrors.email = 'Correo es requerido';
    if (!registerForm.phone) {
      formErrors.phone = 'Teléfono es requerido';
    } else if (!/^\d{10}$/.test(registerForm.phone)) {
      formErrors.phone = 'Teléfono debe contener exactamente 10 números';
    }    if (!registerForm.password) formErrors.password = 'Contraseña es requerida';
    if (registerForm.password !== registerForm.confirmPassword) {
      formErrors.confirmPassword = 'Las contraseñas no coinciden';
    }

    // Validaciones para el formulario del proveedor
    if (registerForm.isProvider) {
      if (!providerForm.companyName) formErrors.companyName = 'Nombre de la empresa es requerido';
      if (!providerForm.ruc) formErrors.ruc = 'RUC es requerido';
      if (!providerForm.phone_em) {
        formErrors.phone_em = 'Teléfono es requerido';
      } else if (!/^\d{10}$/.test(providerForm.phone_em)) {
        formErrors.phone_em = 'Teléfono debe contener exactamente 10 números';
      }
      if (!providerForm.city) formErrors.city = 'Ciudad es requerida';
      if (!providerForm.sector) formErrors.sector = 'Sector es requerido';
      if (!providerForm.parish) formErrors.parish = 'Parroquia es requerida';
      if (!providerForm.mainStreet) formErrors.mainStreet = 'Calle principal es requerida';
      if (!providerForm.secondaryStreet) formErrors.secondaryStreet = 'Calle secundaria es requerida';
      if (!providerForm.number_em) formErrors.number_em = 'Número es requerido';
      if (!providerForm.postalCode) formErrors.postalCode = 'Código postal es requerido';
      if (!providerForm.reference) formErrors.reference = 'Referencia es requerida';
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) return;

    try {
      const credentials = await createUserWithEmailAndPassword(auth, registerForm.email, registerForm.password);
      await sendEmailVerification(credentials.user);

      const userData = {
        userId: credentials.user.uid,
        email: credentials.user.email,
        name: registerForm.name,
        lastName: registerForm.lastName,
        role: 'user',
      };

      if (registerForm.isProvider) {
        userData.providerDetails = { ...providerForm };
      }

      await setDoc(doc(db, 'usuarios', credentials.user.uid), userData);
      handleTabChange('verifyEmail');

      // Si es proveedor, enviar correo
      if (registerForm.isProvider) {
        sendProviderEmail(providerForm); // Llamar la función para enviar correo
      }
    } catch (error) {
      toast.error("Error al registrar el usuario:");

      console.log('Error al registrar el usuario: ' + error.message);
    }
  };

  const sendProviderEmail = (providerDetails) => {
    const message = [
      `Nombre de la empresa: ${providerDetails.companyName}`,
      `RUC: ${providerDetails.ruc}`,
      `Teléfono: ${providerDetails.phone_em}`,
      `Ciudad: ${providerDetails.city}`,
      `Sector: ${providerDetails.sector}`,
      `Parroquia: ${providerDetails.parish}`,
      `Calle principal: ${providerDetails.mainStreet}`,
      `Calle secundaria: ${providerDetails.secondaryStreet}`,
      `Número de teléfono/em: ${providerDetails.number_em}`,
      `Código postal: ${providerDetails.postalCode}`,
      `Referencia: ${providerDetails.reference}`
    ].join('\n');  // Unir todos los elementos del array en un solo string, separado por saltos de línea

    // Enviar el mensaje usando emailjs
    emailjs.send(
      'service_weot8z6', // Reemplaza con tu service ID
      'template_6p6g49j', // Reemplaza con tu template ID
      { message },
      'rQVGkHAuA0UsUrEo9' // Reemplaza con tu user ID de EmailJS  
    )
      .then((response) => {
        console.log('Correo enviado exitosamente', response);
      })
      .catch((error) => {
        console.error('Error al enviar el correo', error);
      });
  };

  const openModal = () => {
    setIsModalOpen(true);  // Abre el modal
    console.log('Modal abierto');
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen); // Cambia el estado del modal
    if (!isModalOpen) {
      console.log('Modal abierto');
    } else {
      console.log('Modal cerrado');
    }
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setRegisterForm((prevForm) => ({
      ...prevForm,
      isProvider: isChecked,
    }));
    if (isChecked) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  };

  return (

    <div className="register-container">
      <ToastContainer />

      <img src={logor} alt="logor" className="logor" />
      <form className="form-container-reg" onSubmit={handleRegisterSubmit}>
        <div className={`floating-label2 ${errors.name ? 'error' : ''}`}>
          <input id="name" type="text" placeholder=" " value={registerForm.name} onChange={handleRegisterChange} required />
          <label htmlFor="name">Nombre</label>
          {errors.name && <p className="error-message">{errors.name}</p>}
        </div>
        <div className={`floating-label2 ${errors.lastName ? 'error' : ''}`}>
          <input id="lastName" placeholder=" " value={registerForm.lastName} onChange={handleRegisterChange} required />
          <label htmlFor="lastName">Apellido</label>
          {errors.lastName && <p className="error-message">{errors.lastName}</p>}
        </div>
        <div className={`floating-label2 ${errors.email ? 'error' : ''}`}>
          <input id="email" type="email" placeholder=" " value={registerForm.email} onChange={handleRegisterChange} required />
          <label htmlFor="email">Correo</label>
          {errors.email && <p className="error-message">{errors.email}</p>}
        </div>
        <div className={`floating-label2 ${errors.phone ? 'error' : ''}`}>
          <input id="phone" type="phone" placeholder=" " value={registerForm.phone} onChange={handleRegisterChange} required />
          <label htmlFor="phone">Teléfono</label>
          {errors.phone && <p className="error-message">{errors.phone}</p>}
        </div>
        <div className={`floating-label2 ${errors.password ? 'error' : ''}`}>
          <div className='pasword_registerform'>
            <input id="password" type={isPasswordVisible ? 'text' : 'password'} placeholder=" " value={registerForm.password} onChange={handleRegisterChange} required />

            <label htmlFor="password">Contraseña</label>
            <FaRegEye className="toggle-password-icon" onClick={togglePasswordVisibility} />
            {errors.password && <p className="error-message">{errors.password}</p>}
          </div>
        </div>
        <div className={`floating-label2 ${errors.confirmPassword ? 'error' : ''}`}>
          <input id="confirmPassword" type={isPasswordVisible ? 'text' : 'password'} placeholder=" " value={registerForm.confirmPassword} onChange={handleRegisterChange} required />
          <label htmlFor="confirmPassword">Confirmar Contraseña</label>
          {errors.confirmPassword && <p className="error-message">{errors.confirmPassword}</p>}
        </div>

        <div className="floating-label2">
          <label className='label_check' style={{ position: 'relative' }} >Quiero ser Anfitrión</label>
          <input
            type="checkbox"
            id="isProvider"
            checked={registerForm.isProvider}
            onChange={handleCheckboxChange}
            className='input_check'
          />
        </div>
      </form>

      {isModalOpen && (
        <div className="modal-prov">
          <div className="modal-content-prov">
            <h4 className='titulo_form_prov'>Información para ser Anfitrión </h4>
            <form className='form_n_prov'>
              <div className="input-group">
                <input id="companyName" placeholder="Razón Social" value={providerForm.companyName} onChange={handleProviderChange} required />
                {errors.companyName && <p className="error-message">{errors.companyName}</p>}
              </div>
              <div className="input-group">
                <input id="ruc" placeholder="RUC" value={providerForm.ruc} onChange={handleProviderChange} required />
                {errors.ruc && <p className="error-message">{errors.ruc}</p>}
              </div>
              <div className="input-group">
                <input id="phone_em" placeholder="Teléfono" value={providerForm.phone_em} onChange={handleProviderChange} required />
                {errors.phone_em && <p className="error-message">{errors.phone_em}</p>}
              </div>
              <div className="input-group">
                <input id="city" placeholder="Ciudad" value={providerForm.city} onChange={handleProviderChange} required />
                {errors.city && <p className="error-message">{errors.city}</p>}
              </div>
              <div className="input-group">
                <input id="sector" placeholder="Sector" value={providerForm.sector} onChange={handleProviderChange} required />
                {errors.sector && <p className="error-message">{errors.sector}</p>}
              </div>
              <div className="input-group">
                <input id="parish" placeholder="Parroquia" value={providerForm.parish} onChange={handleProviderChange} required />
                {errors.parish && <p className="error-message">{errors.parish}</p>}
              </div>
              <div className="input-group">
                <input id="mainStreet" placeholder="Calle Principal" value={providerForm.mainStreet} onChange={handleProviderChange} required />
                {errors.mainStreet && <p className="error-message">{errors.mainStreet}</p>}
              </div>
              <div className="input-group">
                <input id="secondaryStreet" placeholder="Calle Secundaria" value={providerForm.secondaryStreet} onChange={handleProviderChange} required />
                {errors.secondaryStreet && <p className="error-message">{errors.secondaryStreet}</p>}
              </div>
              <div className="input-group">
                <input id="number_em" placeholder="Número" value={providerForm.number_em} onChange={handleProviderChange} required />
                {errors.number_em && <p className="error-message">{errors.number_em}</p>}
              </div>
              <div className="input-group">
                <input id="postalCode" placeholder="Código Postal" value={providerForm.postalCode} onChange={handleProviderChange} required />
                {errors.postalCode && <p className="error-message">{errors.postalCode}</p>}
              </div>
              <div className="input-group">
                <textarea id="reference" placeholder="Referencia" value={providerForm.reference} onChange={handleProviderChange} required />
                {errors.reference && <p className="error-message">{errors.reference}</p>}
              </div>
              <div className="button-group">
                <button type="submit" className="btn-submit" onClick={handleProviderSubmit}>Guardar</button>
                <button type="button" onClick={toggleModal} className="btn-close-modal">Cerrar</button>
              </div>
            </form>
            {  /*          <button type="button" onClick={toggleModal} className="btn-close-modal">Cerrar</button>
*/}          </div>
        </div>

      )}
      {/* Si el modal está cerrado y el usuario es proveedor, muestra un botón para abrirlo */}
      {registerForm.isProvider && !isModalOpen && (
        <button
          onClick={openModal}
          className="btn-open-modal"
        >
          Completar información de proveedor
        </button>
      )}
      <div className="registrarse">
        <button type="submit" className="btn-reg" onClick={handleRegisterSubmit}>Registrarse</button>
      </div>
      {/* Información para cambiar entre registro e inicio de sesión */}
      <div className="info-message">
        ¿Ya tienes una cuenta?
        <span className="clickable" onClick={() => handleTabChange('login')}> Inicia sesión aquí.</span>
      </div>
      {isModalOpen && isFormSubmitted && (
      <div className="modal-prov">
        <div className="modal-content-prov">
          <h4 className='titulo_form_prov'>¡Proveedor Guardado Exitosamente!</h4>
          <p>La información del proveedor se ha guardado correctamente.</p>
          <button onClick={toggleModal}>Cerrar</button>
        </div>
      </div>
    )}
    </div>

  );
};

export default RegisterForm;
